<template>
  <ETripadvisorEntity
    v-if="tripadvisor"
    v-bind="{ ...baseProps, tripadvisor }"
    v-on="baseListeners"
  />
  <EBaseEntity v-else v-bind="baseProps" v-on="baseListeners">
    <template #content-end>
      <EClimateActionTracker
        v-if="climateActionTracker"
        v-bind="climateActionTracker"
        :entity-name="title"
        :level="climateActionTracker.level"
        :url="climateActionTracker.url"
      />
      <EWeather
        v-if="weather"
        :location-name="title"
        @sources="addSources"
      />
    </template>
  </EBaseEntity>
</template>

<script>
import { mapGetters } from 'vuex';
import { trackClick, trackImpression, PAGE_SERP, TYPE_ENTITY } from '~~/search/common/js/client/analytics/rich-content';

import EBaseEntity from './base/index';
import ETripadvisorEntity from './tripadvisor';
import EClimateActionTracker from './climate-action-tracker';
import EWeather from './weather';

export const TRACK_ID_TRIPADVISOR = 'tripadvisor';
export const TRACK_ID_SIMPLE = 'simple';

export default {
  name: 'EEntity',
  components: {
    EBaseEntity,
    ETripadvisorEntity,
    EClimateActionTracker,
    EWeather,
  },
  props: {
    ...EBaseEntity.props,
    extensions: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    extraSources: [],
  }),
  computed: {
    ...mapGetters(['hasMainlineWeather']),
    tripadvisor() {
      return this.extensions.find(({ type }) => type === 'tripadvisor');
    },
    climateActionTracker() {
      return this.extensions.find(({ type }) => type === 'climateActionResult');
    },
    baseProps() {
      return {
        ...this.$props,
        sources: this.sources.concat(this.extraSources),
        // strip away the `extensions` prop
        extensions: undefined,
      };
    },
    isCountry() {
      return this.entityTypes.includes('COUNTRY');
    },
    weather() {
      return this.entityTypes.includes('PLACE') && !this.hasMainlineWeather;
    },
    trackId() {
      if (this.tripadvisor) {
        return TRACK_ID_TRIPADVISOR;
      }

      return TRACK_ID_SIMPLE;
    },
    trackingOptions() {
      return {
        name: this.trackId,
        type: TYPE_ENTITY,
      };
    },
    // these event listeners apply to all Entity types
    baseListeners() {
      return {
        'read-more-click': trackClick({
          ...this.trackingOptions,
          target: 'read_more',
        }),
        'link-click': (link) => trackClick({
          ...this.trackingOptions,
          target: `${link}_link`,
        })(),
        'gallery-image-click': trackClick({
          ...this.trackingOptions,
          target: 'gallery_image',
        }),
        'main-image-click': trackClick({
          ...this.trackingOptions,
          target: 'main_image',
        }),
      };
    },
  },
  mounted() {
    trackImpression({
      ...this.trackingOptions,
      page: PAGE_SERP,
      once: true,
    });
  },
  methods: {
    addSources(sources) {
      this.extraSources = this.extraSources.concat(sources);
    },
  },
};
</script>
